// extracted by mini-css-extract-plugin
module.exports = {"videoPage":"videoPage_videoPage__VZDFQ","videoList":"videoPage_videoList__GzYyh","cpVideo":"videoPage_cpVideo__XTRDV","listEnd":"videoPage_listEnd__7jeCl"};